// Shoutout to Ant-Design for most the colors
const color: {
  gray1: string;
  gray2: string;
  gray3: string;
  gray4: string;
  gray5: string;
  gray6: string;
  gray7: string;
  gray8: string;
  gray9: string;
  gray10: string;
  gray11: string;
  gray12: string;
  gray13: string;

  dark: {
    red1: string;
    red2: string;
    red3: string;
    red4: string;
    red5: string;
    red6: string;
    red7: string;
    red8: string;
    red9: string;
    red10: string;

    volcano1: string;
    volcano2: string;
    volcano3: string;
    volcano4: string;
    volcano5: string;
    volcano6: string;
    volcano7: string;
    volcano8: string;
    volcano9: string;
    volcano10: string;

    orange1: string;
    orange2: string;
    orange3: string;
    orange4: string;
    orange5: string;
    orange6: string;
    orange7: string;
    orange8: string;
    orange9: string;
    orange10: string;

    gold1: string;
    gold2: string;
    gold3: string;
    gold4: string;
    gold5: string;
    gold6: string;
    gold7: string;
    gold8: string;
    gold9: string;
    gold10: string;

    green1: string;
    green2: string;
    green3: string;
    green4: string;
    green5: string;
    green6: string;
    green7: string;
    green8: string;
    green9: string;
    green10: string;

    cyan1: string;
    cyan2: string;
    cyan3: string;
    cyan4: string;
    cyan5: string;
    cyan6: string;
    cyan7: string;
    cyan8: string;
    cyan9: string;
    cyan10: string;

    blue1: string;
    blue2: string;
    blue3: string;
    blue4: string;
    blue5: string;
    blue6: string;
    blue7: string;
    blue8: string;
    blue9: string;
    blue10: string;

    geekblue1: string;
    geekblue2: string;
    geekblue3: string;
    geekblue4: string;
    geekblue5: string;
    geekblue6: string;
    geekblue7: string;
    geekblue8: string;
    geekblue9: string;
    geekblue10: string;

    purple1: string;
    purple2: string;
    purple3: string;
    purple4: string;
    purple5: string;
    purple6: string;
    purple7: string;
    purple8: string;
    purple9: string;
    purple10: string;

    magenta1: string;
    magenta2: string;
    magenta3: string;
    magenta4: string;
    magenta5: string;
    magenta6: string;
    magenta7: string;
    magenta8: string;
    magenta9: string;
    magenta10: string;
  };

  light: {
    blue1: string;
    blue2: string;
    blue3: string;
    blue4: string;
    blue5: string;
    blue6: string;
    blue7: string;
    blue8: string;
    blue9: string;
    blue10: string;

    geekblue1: string;
    geekblue2: string;
    geekblue3: string;
    geekblue4: string;
    geekblue5: string;
    geekblue6: string;
    geekblue7: string;
    geekblue8: string;
    geekblue9: string;
    geekblue10: string;

    orange1: string;
    orange2: string;
    orange3: string;
    orange4: string;
    orange5: string;
    orange6: string;
    orange7: string;
    orange8: string;
    orange9: string;
    orange10: string;

    red1: string;
    red2: string;
    red3: string;
    red4: string;
    red5: string;
    red6: string;
    red7: string;
    red8: string;
    red9: string;
    red10: string;

    volcano1: string;
    volcano2: string;
    volcano3: string;
    volcano4: string;
    volcano5: string;
    volcano6: string;
    volcano7: string;
    volcano8: string;
    volcano9: string;
    volcano10: string;

    gold1: string;
    gold2: string;
    gold3: string;
    gold4: string;
    gold5: string;
    gold6: string;
    gold7: string;
    gold8: string;
    gold9: string;
    gold10: string;

    yellow1: string;
    yellow2: string;
    yellow3: string;
    yellow4: string;
    yellow5: string;
    yellow6: string;
    yellow7: string;
    yellow8: string;
    yellow9: string;
    yellow10: string;

    lime1: string;
    lime2: string;
    lime3: string;
    lime4: string;
    lime5: string;
    lime6: string;
    lime7: string;
    lime8: string;
    lime9: string;
    lime10: string;

    green1: string;
    green2: string;
    green3: string;
    green4: string;
    green5: string;
    green6: string;
    green7: string;
    green8: string;
    green9: string;
    green10: string;

    cyan1: string;
    cyan2: string;
    cyan3: string;
    cyan4: string;
    cyan5: string;
    cyan6: string;
    cyan7: string;
    cyan8: string;
    cyan9: string;
    cyan10: string;

    purple1: string;
    purple2: string;
    purple3: string;
    purple4: string;
    purple5: string;
    purple6: string;
    purple7: string;
    purple8: string;
    purple9: string;
    purple10: string;

    magenta1: string;
    magenta2: string;
    magenta3: string;
    magenta4: string;
    magenta5: string;
    magenta6: string;
    magenta7: string;
    magenta8: string;
    magenta9: string;
    magenta10: string;
  };
} = {
  // neutrals
  gray1: "#ffffff",
  gray2: "#fafafa",
  gray3: "#f5f5f5",
  gray4: "#f0f0f0",
  gray5: "#d9d9d9",
  gray6: "#bfbfbf",
  gray7: "#8c8c8c",
  gray8: "#595959",
  gray9: "#434343",
  gray10: "#262626",
  gray11: "#1f1f1f",
  gray12: "#141414",
  gray13: "#000000",

  // dark mode!
  dark: {
    // reds
    red1: "#2a1215",
    red2: "#431418",
    red3: "#58181c",
    red4: "#791a1f",
    red5: "#a61d24",
    red6: "#d32029",
    red7: "#e84749",
    red8: "#f37370",
    red9: "#f89f9a",
    red10: "#fac8c3",

    // volcano
    volcano1: "#2b1611",
    volcano2: "#441d12",
    volcano3: "#592716",
    volcano4: "#7c3118",
    volcano5: "#aa3e19",
    volcano6: "#d84a1b",
    volcano7: "#e87040",
    volcano8: "#f3956a",
    volcano9: "#f8b692",
    volcano10: "#fad4bc",

    // sunset orange
    orange1: "#2b1d11",
    orange2: "#442a11",
    orange3: "#593815",
    orange4: "#7c4a15",
    orange5: "#aa6215",
    orange6: "#d87a16",
    orange7: "#e89a3c",
    orange8: "#f3b765",
    orange9: "#f8cf8d",
    orange10: "#fae3b7",

    // gold
    gold1: "#2b2111",
    gold2: "#443111",
    gold3: "#594214",
    gold4: "#7c5914",
    gold5: "#aa7714",
    gold6: "#d89614",
    gold7: "#e8b339",
    gold8: "#f3cc62",
    gold9: "#f8df8b",
    gold10: "#faedb5",

    // polar green
    green1: "#162312",
    green2: "#1d3712",
    green3: "#274916",
    green4: "#306317",
    green5: "#3c8618",
    green6: "#49aa19",
    green7: "#6abe39",
    green8: "#8fd460",
    green9: "#b2e58b",
    green10: "#d5f2bb",

    // cyan
    cyan1: "#112123",
    cyan2: "#113536",
    cyan3: "#144848",
    cyan4: "#146262",
    cyan5: "#138585",
    cyan6: "#13a8a8",
    cyan7: "#33bcb7",
    cyan8: "#58d1c9",
    cyan9: "#84e2d8",
    cyan10: "#b2f1e8",

    // daybreak blue
    blue1: "#111d2c",
    blue2: "#112a45",
    blue3: "#15395b",
    blue4: "#164c7e",
    blue5: "#1765ad",
    blue6: "#177ddc",
    blue7: "#3c9ae8",
    blue8: "#65b7f3",
    blue9: "#8dcff8",
    blue10: "#b7e3fa",

    // geek blue
    geekblue1: "#131629",
    geekblue2: "#161d40",
    geekblue3: "#1c2755",
    geekblue4: "#203175",
    geekblue5: "#263ea0",
    geekblue6: "#2b4acb",
    geekblue7: "#5273e0",
    geekblue8: "#7f9ef3",
    geekblue9: "#a8c1f8",
    geekblue10: "#d2e0fa",

    // purple
    purple1: "#1a1325",
    purple2: "#24163a",
    purple3: "#301c4d",
    purple4: "#3e2069",
    purple5: "#51258f",
    purple6: "#642ab5",
    purple7: "#854eca",
    purple8: "#ab7ae0",
    purple9: "#cda8f0",
    purple10: "#ebd7fa",

    // magenta
    magenta1: "#291321",
    magenta2: "#40162f",
    magenta3: "#551c3b",
    magenta4: "#75204f",
    magenta5: "#a02669",
    magenta6: "#cb2b83",
    magenta7: "#e0529c",
    magenta8: "#f37fb7",
    magenta9: "#f8a8cc",
    magenta10: "#fad2e3",
  },

  // light mode :O
  light: {
    blue1: "#e6f7ff",
    blue2: "#bae7ff",
    blue3: "#91d5ff",
    blue4: "#69c0ff",
    blue5: "#40a9ff",
    blue6: "#1890ff",
    blue7: "#096dd9",
    blue8: "#0050b3",
    blue9: "#003a8c",
    blue10: "#002766",

    geekblue1: "#f0f5ff",
    geekblue2: "#d6e4ff",
    geekblue3: "#adc6ff",
    geekblue4: "#85a5ff",
    geekblue5: "#597ef7",
    geekblue6: "#2f54eb",
    geekblue7: "#1d39c4",
    geekblue8: "#10239e",
    geekblue9: "#061178",
    geekblue10: "#030852",

    // secondary oranges
    orange1: "#fff7e6",
    orange2: "#ffe7ba",
    orange3: "#ffd591",
    orange4: "#ffc069",
    orange5: "#ffa940",
    orange6: "#fa8c16",
    orange7: "#d46b08",
    orange8: "#ad4e00",
    orange9: "#873800",
    orange10: "#612500",

    // red
    red1: "#fff1f0",
    red2: "#ffccc7",
    red3: "#ffa39e",
    red4: "#ff7875",
    red5: "#ff4d4f",
    red6: "#f5222d",
    red7: "#cf1322",
    red8: "#a8071a",
    red9: "#820014",
    red10: "#5c0011",

    // volcano
    volcano1: "#fff2e8",
    volcano2: "#ffd8bf",
    volcano3: "#ffbb96",
    volcano4: "#ff9c6e",
    volcano5: "#ff7a45",
    volcano6: "#fa541c",
    volcano7: "#d4380d",
    volcano8: "#ad2102",
    volcano9: "#871400",
    volcano10: "#610b00",

    // gold
    gold1: "#fffbe6",
    gold2: "#fff1b8",
    gold3: "#ffe58f",
    gold4: "#ffd666",
    gold5: "#ffc53d",
    gold6: "#faad14",
    gold7: "#d48806",
    gold8: "#ad6800",
    gold9: "#874d00",
    gold10: "#613400",

    // yellow
    yellow1: "#feffe6",
    yellow2: "#ffffb8",
    yellow3: "#fffb8f",
    yellow4: "#fff566",
    yellow5: "#ffec3d",
    yellow6: "#fadb14",
    yellow7: "#d4b106",
    yellow8: "#ad8b00",
    yellow9: "#876800",
    yellow10: "#614700",

    // lime
    lime1: "#fcffe6",
    lime2: "#f4ffb8",
    lime3: "#eaff8f",
    lime4: "#d3f261",
    lime5: "#bae637",
    lime6: "#a0d911",
    lime7: "#7cb305",
    lime8: "#5b8c00",
    lime9: "#3f6600",
    lime10: "#254000",

    // green
    green1: "#f6ffed",
    green2: "#d9f7be",
    green3: "#b7eb8f",
    green4: "#95de64",
    green5: "#73d13d",
    green6: "#52c41a",
    green7: "#389e0d",
    green8: "#237804",
    green9: "#135200",
    green10: "#092b00",

    // cyan
    cyan1: "#e6fffb",
    cyan2: "#b5f5ec",
    cyan3: "#87e8de",
    cyan4: "#5cdbd3",
    cyan5: "#36cfc9",
    cyan6: "#13c2c2",
    cyan7: "#08979c",
    cyan8: "#006d75",
    cyan9: "#00474f",
    cyan10: "#002329",

    // purple
    purple1: "#f9f0ff",
    purple2: "#efdbff",
    purple3: "#d3adf7",
    purple4: "#b37feb",
    purple5: "#9254de",
    purple6: "#722ed1",
    purple7: "#531dab",
    purple8: "#391085",
    purple9: "#22075e",
    purple10: "#120338",

    // magenta
    magenta1: "#fff0f6",
    magenta2: "#ffd6e7",
    magenta3: "#ffadd2",
    magenta4: "#ff85c0",
    magenta5: "#f759ab",
    magenta6: "#eb2f96",
    magenta7: "#c41d7f",
    magenta8: "#9e1068",
    magenta9: "#780650",
    magenta10: "#520339",
  },
};

export default color;
